import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck, faCircleExclamation, faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

type ToastType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [NgClass, FaIconComponent, TranslateModule],
})
export class ToastComponent {
  title = '';
  message = '';
  isVisible = false;
  faXmark = faXmark;
  toastIcon!: any;
  animationClass = '';
  toastType: ToastType = 'info';

  show(message: string, type: ToastType = 'info', duration = 5000, title = '') {
    this.title = title;
    this.message = message;
    this.toastType = type;
    this.toastIcon = this.getToastIcon(type);

    this.isVisible = true;
    this.animationClass = '';

    setTimeout(() => {
      this.animationClass = 'show';
    }, 50);

    setTimeout(() => this.hide(), duration);
  }

  hide() {
    this.animationClass = 'hide';

    setTimeout(() => {
      this.isVisible = false;
      this.animationClass = '';
    }, 800);
  }

  close() {
    this.hide();
  }

  private getToastIcon(type: ToastType): any {
    switch (type) {
      case 'success':
        return faCircleCheck;
      case 'error':
        return faCircleExclamation;
      case 'warning':
        return faCircleExclamation;
      case 'info':
      default:
        return faCircleInfo;
    }
  }
}
